module.exports = __webpack_public_path__ + "static/flags/GT-ec5ecd9b7961ded0cad710bd74131421.gif";